import { GroupKindEnum, SkillKindEnum } from '../graphql/generated/definitions';

export function getGroupColor(type: GroupKindEnum): string {
  switch (type) {
    case "Partner":
      return "blue";
    case "Subsidiary":
      return "yellow";
    case "Team":
      return "purple";
    case "TrainingCourse":
      return "pink";
    default:
      return "orange";
  }
}

export function getSkillsColor(kind: SkillKindEnum): string {
  switch (kind) {
    case "hard":
      return "blue";
    case "soft":
      return "purple";
    default:
      return "pink";
  }
}
